import { noop, type Unsubscribe } from '@amazon/vinyl-util'
import { isTv } from '@/device/deviceConfig'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('initializeExternalLinkHandoff')

/** Lazy entry point so non-TV bundles never download the handler. */
export function initializeExternalLinkHandoff(): Unsubscribe {
    if (!isTv()) return noop

    let disposed = false
    let teardown: Unsubscribe | undefined

    import('./bindExternalLinkHandoff')
        .then(({ bindExternalLinkHandoff }) => {
            if (!disposed) teardown = bindExternalLinkHandoff()
        })
        .catch(errorHandler)

    return () => {
        disposed = true
        teardown?.()
        teardown = undefined
    }
}
